import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eyeShow",
  "use": "eyeShow-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 14\" id=\"eyeShow\">\n<path d=\"M8.1,2C5.2,2,2.5,3.1,0.5,4.9c-0.6,0.5-0.7,1.3-0.2,1.9S1.6,7.5,2.2,7c0.5,2.8,3,5,5.9,5c3,0,5.4-2.2,5.9-5\n\tc0.6,0.4,1.3,0.2,1.8-0.3c0.4-0.5,0.4-1.3-0.1-1.8C13.6,3.1,10.9,2,8.1,2z M4.8,5.3c0,0.2-0.1,0.4-0.1,0.7c0,1.8,1.5,3.3,3.3,3.3\n\ts3.3-1.5,3.3-3.3c0-0.2,0-0.5-0.1-0.7c0.5,0.2,1,0.4,1.4,0.7c0,2.6-2.1,4.6-4.6,4.6c-2.6,0-4.6-2.1-4.6-4.6C3.8,5.8,4.3,5.5,4.8,5.3\n\tz\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol